module.exports = __webpack_public_path__ + "img/wxcode.75765461.jpg";